const green = {
  50: "#e6f5e5",
  100: "#c3e5be",
  200: "#9cd494",
  300: "#72c568",
  400: "#4fb846",
  500: "#26ab1c",
  600: "#1a9d12",
  700: "#008b00",
  800: "#007a00",
  900: "#005c00",
};

export default green;
